import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import type { IResponseConversationDraftMessage } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventClientDraft = () => {
  const { websocket, conversationStore } = useEntitiesContext()

  const handle = (data: IResponseConversationDraftMessage) => {
    conversationStore.addItemDraft(data)
    conversationStore.increaseItemsTotalDraftCount(data.conversation_id)
  }

  useEffect(() => websocket.on(WebsocketEvent.ClientDraft, handle), [])
}
